<template>
  <aside
    class="bg-light text-dark shadow border-right component-menubar-sidebar transition-all"
    :style="sidebarStyle"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @touchstart.stop="handleTouchStart"
    @click.stop
  >
    <router-link
      :to="{ name: 'Clinic' }"
      class="navbar-brand text-dark text-decoration-none d-block p-3"
    >
      <img
        src="@/assets/img/dentcloud-logo-darkblue.png"
        alt="Pastel Logo"
        class="d-inline-block"
        style="height: 30px"
        :style="{ marginRight: effectivelyCollapsed ? '0' : '0.5rem' }"
      />
      <span v-show="showText" class="brand-text">DentCloud</span>
    </router-link>
    <div class="">
      <nav class="mt-2">
        <b-nav v-if="hasClinicBranchUrl()" vertical class="flex-column">
          <b-nav-item
            v-if="isAccessMenu(['DOCTOR'])"
            :to="{ name: 'Dashboard' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'Dashboard' }"
            :title="effectivelyCollapsed ? 'ปฏิทินแพทย์' : ''"
          >
            <i
              class="fas fa-user-md"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">ปฏิทินแพทย์</span>
          </b-nav-item>

          <b-nav-item
            v-if="isAccessMenu(['ASSISTANT'])"
            :to="{ name: 'DoctorsTreatingQueue' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'DoctorsTreatingQueue' }"
            :title="effectivelyCollapsed ? 'ปฏิทินแพทย์ทุกท่าน' : ''"
          >
            <i
              class="far fa-calendar-plus"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">ปฏิทินแพทย์ทุกท่าน</span>
          </b-nav-item>

          <b-nav-item
            v-if="
              isAccessMenu(['ASSISTANT', 'COUNTER', 'MANAGER', 'HEADCOUNTER'])
            "
            :to="{ name: 'QueueManage' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'QueueManage' }"
            :title="effectivelyCollapsed ? 'ปฏิทินนัดหมาย' : ''"
          >
            <i
              class="far fa-calendar-alt"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">ปฏิทินนัดหมาย</span>
          </b-nav-item>

          <b-nav-item
            v-if="
              isAccessMenu(['ASSISTANT', 'COUNTER', 'MANAGER', 'HEADCOUNTER'])
            "
            :to="{ name: 'QueueList' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'QueueList' }"
            :title="effectivelyCollapsed ? 'รายการนัดหมาย' : ''"
          >
            <i
              class="far fa-calendar-minus"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">รายการนัดหมาย</span>
          </b-nav-item>

          <b-nav-item
            v-if="isAccessMenu(['MANAGER', 'COUNTER', 'HEADCOUNTER'])"
            :to="{ name: 'UserManage' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'UserManage' }"
            :title="effectivelyCollapsed ? 'จัดการผู้ใช้' : ''"
          >
            <i
              class="fas fa-users"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">จัดการผู้ใช้</span>
          </b-nav-item>

          <!-- Lists/Package - Simple Collapsed Icon -->
          <b-nav-item
            v-if="
              isAccessMenu(['COUNTER', 'MANAGER', 'DOCTOR', 'HEADCOUNTER']) &&
              effectivelyCollapsed &&
              !isMobile
            "
            class="text-dark"
            :title="'ลิสต์/แพ็กเกจจัดฟัน'"
            :class="{
              'bg-secondary': checkActiveMenu([
                'packagemanage',
                'aptlistmanage',
                'txlistmanage',
                'dxlistmanage',
                'itemslistmanage',
                'labproductmanage',
              ]),
            }"
          >
            <i class="fas fa-list"></i>
          </b-nav-item>

          <!-- Lists/Package Dropdown - Expanded -->
          <div
            v-if="
              isAccessMenu(['COUNTER', 'MANAGER', 'DOCTOR', 'HEADCOUNTER']) &&
              (!effectivelyCollapsed || (isMobile && mobileOpen))
            "
          >
            <b-button
              v-b-toggle.collapse-lists
              variant="link"
              class="text-dark text-decoration-none d-flex align-items-center justify-content-between w-100 p-2 px-3"
              :class="{
                'bg-secondary': checkActiveMenu([
                  'packagemanage',
                  'aptlistmanage',
                  'txlistmanage',
                  'dxlistmanage',
                  'itemslistmanage',
                ]),
              }"
            >
              <span>
                <i class="fas fa-list mr-2"></i>
                <span v-show="showText">ลิสต์/แพ็กเกจจัดฟัน</span>
              </span>
              <i class="fas fa-angle-down"></i>
            </b-button>
            <b-collapse id="collapse-lists" class="ml-3">
              <b-nav-item
                :to="{ name: 'PackageManage' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'PackageManage' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">แพ็กเกจจัดฟัน</span>
              </b-nav-item>
              <b-nav-item
                :to="{ name: 'AptListManage' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'AptListManage' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ลิสต์นัดหมาย</span>
              </b-nav-item>
              <b-nav-item
                :to="{ name: 'TxListManage' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'TxListManage' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ลิสต์การรักษา</span>
              </b-nav-item>
              <b-nav-item
                :to="{ name: 'DxListManage' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'DxListManage' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ลิสต์การวินิจฉัย</span>
              </b-nav-item>
              <b-nav-item
                :to="{ name: 'ItemsListManage' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'ItemsListManage' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ลิสต์ยา และสินค้า</span>
              </b-nav-item>
              <b-nav-item
                :to="{ name: 'LabProductManage' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'LabProductManage' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ลิสต์แลป</span>
              </b-nav-item>
            </b-collapse>
          </div>

          <b-nav-item
            v-if="isAccessMenu(['COUNTER', 'MANAGER', 'HEADCOUNTER'])"
            :to="{ name: 'ReceiptManage' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'ReceiptManage' }"
            :title="effectivelyCollapsed ? 'จัดการใบเสร็จ' : ''"
          >
            <i
              class="fas fa-receipt"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">จัดการใบเสร็จ</span>
          </b-nav-item>

          <b-nav-item
            v-if="isAccessMenu(['COUNTER', 'MANAGER', 'HEADCOUNTER'])"
            :to="{ name: 'LabExpense' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'LabExpense' }"
            :title="effectivelyCollapsed ? 'จัดการค่าแลป' : ''"
          >
            <i
              class="fas fa-file-invoice-dollar"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">จัดการค่าแลป</span>
          </b-nav-item>

          <b-nav-item
            v-if="
              isAccessMenu(['MANAGER', 'HEADCOUNTER']) &&
              getBranchInfo.fileStoreExpiration
            "
            :to="{ name: 'FileManage' }"
            class="text-dark"
            :class="{ 'bg-secondary': $route.name === 'FileManage' }"
            :title="effectivelyCollapsed ? 'จัดการไฟล์' : ''"
          >
            <i
              class="fas fa-file"
              :class="{ 'mr-2': !effectivelyCollapsed }"
            ></i>
            <span v-show="showText">จัดการไฟล์</span>
          </b-nav-item>

          <!-- ----------product and stock---------- -->
          <b-nav-item
            v-if="
              isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER', 'ROLE_STOCK_STAFF']) &&
              effectivelyCollapsed &&
              !isMobile
            "
            class="text-dark"
            :title="'จัดการสินค้าคงคลัง'"
            :class="{
              'bg-secondary': checkActiveMenu([
                'unitMaster',
                'GoodsReceive',
                'ProductInventory',
                'TransferInventory',
                'CategoryMaster',
              ]),
            }"
          >
            <i class="fas fa-boxes"></i>
          </b-nav-item>

          <div
            v-if="
              isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER', 'ROLE_STOCK_STAFF']) &&
              (!effectivelyCollapsed || (isMobile && mobileOpen))
            "
          >
            <b-button
              v-b-toggle.collapse-product-management
              variant="link"
              class="text-dark text-decoration-none d-flex align-items-center justify-content-between w-100 p-2 px-3"
              :class="{
                'bg-secondary': checkActiveMenu([
                  'unitMaster',
                  'GoodsReceive',
                  'ProductInventory',
                  'TransferInventory',
                  'CategoryMaster',
                ]),
              }"
            >
              <span>
                <i class="fas fa-boxes mr-2"></i>
                <span v-show="showText">จัดการสินค้าคงคลัง</span>
              </span>
              <i class="fas fa-angle-down"></i>
            </b-button>
            <b-collapse id="collapse-product-management" class="ml-3">
              <!-- ProductInventory -->
              <b-nav-item
                :to="{ name: 'ProductInventory' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'ProductInventory' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">สินค้าและสต๊อก</span>
              </b-nav-item>

              <!-- GoodsReceive -->
              <b-nav-item
                :to="{ name: 'GoodsReceive' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'GoodsReceive' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ใบรับสินค้า</span>
              </b-nav-item>

              <!-- TransferInventory -->
              <b-nav-item
                :to="{ name: 'TransferInventory' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'TransferInventory' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ใบโอนสินค้า</span>
              </b-nav-item>

              <!-- Category Master -->
              <b-nav-item
                :to="{ name: 'CategoryMaster' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'CategoryMaster' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ตั้งค่าหมวดหมู่สินค้า</span>
              </b-nav-item>

              <!-- UnitMaster -->
              <b-nav-item
                :to="{ name: 'UnitMaster' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'UnitMaster' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ตั้งค่าหน่วยสินค้า</span>
              </b-nav-item>
            </b-collapse>
          </div>

          <!-- ----------product and stock---------- -->

          <!-- Reports - Simple Collapsed Icon -->
          <b-nav-item
            v-if="
              isAccessMenu(['COUNTER', 'MANAGER', 'DOCTOR', 'HEADCOUNTER']) &&
              effectivelyCollapsed &&
              !isMobile
            "
            class="text-dark"
            :title="'รายงาน'"
            :class="{
              'bg-secondary': checkActiveMenu([
                'personalincome',
                'branchincome',
              ]),
            }"
          >
            <i class="fas fa-chart-bar"></i>
          </b-nav-item>

          <!-- Reports Dropdown - Expanded -->
          <div
            v-if="
              isAccessMenu(['COUNTER', 'MANAGER', 'DOCTOR', 'HEADCOUNTER']) &&
              (!effectivelyCollapsed || (isMobile && mobileOpen))
            "
          >
            <b-button
              v-b-toggle.collapse-reports
              variant="link"
              class="text-dark text-decoration-none d-flex align-items-center justify-content-between w-100 p-2 px-3"
              :class="{
                'bg-secondary': checkActiveMenu([
                  'personalincome',
                  'branchincome',
                ]),
              }"
            >
              <span>
                <i class="fas fa-chart-bar mr-2"></i>
                <span v-show="showText">รายงาน</span>
              </span>
              <i class="fas fa-angle-down"></i>
            </b-button>
            <b-collapse id="collapse-reports" class="ml-3">
              <b-nav-item
                v-if="
                  isAccessMenu(['COUNTER', 'MANAGER', 'DOCTOR', 'HEADCOUNTER'])
                "
                :to="{ name: 'PersonalIncome' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'PersonalIncome' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">รายได้แพทย์</span>
              </b-nav-item>
              <b-nav-item
                v-if="isAccessMenu(['COUNTER', 'MANAGER', 'HEADCOUNTER'])"
                :to="{ name: 'BranchIncome' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'BranchIncome' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">รายงานสาขา</span>
              </b-nav-item>
            </b-collapse>
          </div>

          <!-- AI Analysis - Simple Collapsed Icon -->
          <b-nav-item
            v-if="
              isAccessMenu(['MANAGER', 'HEADCOUNTER']) &&
              effectivelyCollapsed &&
              !isMobile
            "
            class="text-dark"
            :title="'AI Analysis (Beta)'"
            :class="{
              'bg-secondary': checkActiveMenu([
                'branchanalysis',
                'patientanalysis',
              ]),
            }"
          >
            <i class="fas fa-robot"></i>
          </b-nav-item>

          <!-- AI Analysis Dropdown - Expanded -->
          <div
            v-if="
              isAccessMenu(['MANAGER', 'HEADCOUNTER']) &&
              (!effectivelyCollapsed || (isMobile && mobileOpen))
            "
          >
            <b-button
              v-b-toggle.collapse-ai
              variant="link"
              class="text-dark text-decoration-none d-flex align-items-center justify-content-between w-100 p-2 px-3"
              :class="{
                'bg-secondary': checkActiveMenu([
                  'branchanalysis',
                  'patientanalysis',
                ]),
              }"
            >
              <span>
                <i class="fas fa-robot mr-2"></i>
                <span v-show="showText">AI Analysis (Beta)</span>
              </span>
              <i class="fas fa-angle-down"></i>
            </b-button>
            <b-collapse id="collapse-ai" class="ml-3">
              <b-nav-item
                v-if="isAccessMenu(['MANAGER', 'HEADCOUNTER'])"
                :to="{ name: 'branchAnalysis' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'branchAnalysis' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">รายได้</span>
              </b-nav-item>
              <b-nav-item
                v-if="isAccessMenu(['MANAGER', 'HEADCOUNTER'])"
                :to="{ name: 'PatientAnalysis' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'PatientAnalysis' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ผู้รับบริการ</span>
              </b-nav-item>
              <!-- <b-nav-item
                v-if="isAccessMenu(['MANAGER', 'HEADCOUNTER'])"
                disabled
                class="text-muted py-1"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">นัดหมาย</span>
              </b-nav-item> -->
            </b-collapse>
          </div>

          <!-- Settings - Simple Collapsed Icon -->
          <b-nav-item
            v-if="
              isAccessMenu(['MANAGER', 'HEADCOUNTER']) &&
              effectivelyCollapsed &&
              !isMobile
            "
            class="text-dark"
            :title="'ตั้งค่า'"
            :class="{
              'bg-secondary': checkActiveMenu(['setting', 'subscription']),
            }"
          >
            <i class="fas fa-cog"></i>
          </b-nav-item>

          <!-- Settings Dropdown - Expanded -->
          <div
            v-if="
              isAccessMenu(['MANAGER', 'HEADCOUNTER']) &&
              (!effectivelyCollapsed || (isMobile && mobileOpen))
            "
          >
            <b-button
              v-b-toggle.collapse-settings
              variant="link"
              class="text-dark text-decoration-none d-flex align-items-center justify-content-between w-100 p-2 px-3"
              :class="{
                'bg-secondary': checkActiveMenu(['setting', 'subscription']),
              }"
            >
              <span>
                <i class="fas fa-cog mr-2"></i>
                <span v-show="showText">ตั้งค่า</span>
              </span>
              <i class="fas fa-angle-down"></i>
            </b-button>
            <b-collapse id="collapse-settings" class="ml-3">
              <b-nav-item
                v-if="isAccessMenu(['MANAGER', 'HEADCOUNTER'])"
                :to="{ name: 'Setting' }"
                class="text-dark py-0"
                :class="{ 'bg-secondary': $route.name === 'Setting' }"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">ตั้งค่าสาขา</span>
              </b-nav-item>
              <b-nav-item
                v-if="isAccessMenu(['MANAGER', 'HEADCOUNTER'])"
                :to="{ name: 'Subscription' }"
                :disabled="isProductionEnvironment"
                :class="[
                  'py-1',
                  { 'disabled-menu-item': isProductionEnvironment },
                ]"
              >
                <i class="fas fa-circle mr-2" style="font-size: 0.5rem"></i>
                <span v-show="showText">การสมัครบริการ</span>
              </b-nav-item>
            </b-collapse>
          </div>
        </b-nav>
      </nav>
      <!-- Version number at the bottom of sidebar -->
      <div v-show="showText" class="version-info text-center mt-2 mb-2">
        <small class="text-muted">v{{ version }}</small>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "Sidebar",

  data() {
    return {
      // Sidebar state
      sidebarCollapsed: true,
      isTemporarilyExpanded: false,
      mobileOpen: false,

      // Text visibility
      showText: false,
      textDelayTimer: null,

      // Auto-collapse functionality
      autoCollapseTimer: null,

      // Hover expand functionality
      hoverExpandTimer: null,

      // Responsive behavior
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1024,

      // App info
      authId: 0,
      version:
        process.env.VUE_APP_VERSION || process.env.PACKAGE_VERSION || "1.0.0",
    };
  },

  computed: {
    // Vuex getters
    ...mapGetters({
      authorization: "moduleUser/getAuthorization",
      isAccessMenu: "moduleUser/getIsAccessMenu",
      getBranchInfo: "moduleUser/getBranchInfo",
    }),

    // Device detection
    isTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    },
    isMobile() {
      return this.windowWidth <= 768;
    },

    // Environment detection
    isProductionEnvironment() {
      return process.env.VUE_APP_MODE === "production";
    },

    // Sidebar state
    effectivelyCollapsed() {
      return this.sidebarCollapsed && !this.isTemporarilyExpanded;
    },
    sidebarStyle() {
      const isMobile = this.isMobile;

      let transform = "";
      let zIndex;

      if (isMobile) {
        // Mobile mode: use transform for show/hide, always high z-index
        transform = this.mobileOpen ? "translateX(0)" : "translateX(-100%)";
        zIndex = 1000; // Always high z-index on mobile
      } else {
        // Desktop mode: no transform, z-index based on expansion state
        transform = "";
        zIndex = this.effectivelyCollapsed ? "auto" : 1000;
      }

      // Width calculation
      let width;
      if (isMobile) {
        width = "250px"; // Always full width on mobile
      } else {
        width = this.effectivelyCollapsed ? "60px" : "250px";
      }

      const style = {
        width: width,
        height: "100vh",
        position: "fixed",
        left: "0",
        top: "0",
        zIndex: zIndex,
        transform: transform,
        transition:
          "width 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease",
      };

      return style;
    },
  },
  created() {
    this.authId = this.authorization.authId;
    // Auto-collapse sidebar on clinic path
    this.checkRouteForCollapse();
  },
  mounted() {
    this.initializeEventListeners();
    this.initializeMobileStateObserver();
    this.initializeState();
  },
  watch: {
    // Watch for route changes to auto-collapse sidebar on clinic path
    $route() {
      this.checkRouteForCollapse();
    },
    // Watch for mobile sidebar state changes to update text visibility
    mobileOpen() {
      this.updateTextVisibility();
    },
  },
  beforeDestroy() {
    this.cleanupEventListeners();
    this.cleanupMobileStateObserver();
    this.clearTimers();
  },

  // Methods
  methods: {
    // === Initialization Methods ===
    initializeEventListeners() {
      // Sidebar toggle event
      eventBus.$on("toggleSidebar", () => {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        this.isTemporarilyExpanded = false;
        this.clearAutoCollapseTimer();
        this.updateBodyClass();
        this.updateTextVisibility();
        eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      });

      // Document event listeners
      document.addEventListener("click", this.handleBackdropClick);
      window.addEventListener("resize", this.handleWindowResize);
    },

    initializeMobileStateObserver() {
      this.mobileStateObserver = new MutationObserver(() => {
        const newState = document.body.classList.contains(
          "mobile-sidebar-open"
        );
        this.mobileOpen = newState;
      });
      this.mobileStateObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    },

    initializeState() {
      this.mobileOpen = document.body.classList.contains("mobile-sidebar-open");
      eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      this.updateBodyClass();
      this.updateTextVisibility();
    },

    // === Cleanup Methods ===
    cleanupEventListeners() {
      eventBus.$off("toggleSidebar");
      eventBus.$off("sidebarStateChanged");
      document.removeEventListener("click", this.handleBackdropClick);
      window.removeEventListener("resize", this.handleWindowResize);
    },

    cleanupMobileStateObserver() {
      if (this.mobileStateObserver) {
        this.mobileStateObserver.disconnect();
      }
    },

    clearTimers() {
      this.clearAutoCollapseTimer();
      if (this.textDelayTimer) {
        clearTimeout(this.textDelayTimer);
        this.textDelayTimer = null;
      }
      if (this.hoverExpandTimer) {
        clearTimeout(this.hoverExpandTimer);
        this.hoverExpandTimer = null;
      }
    },

    // === Utility Methods ===
    hasClinicBranchUrl() {
      return !!(this.$route.params.clinicUrl && this.$route.params.branchUrl);
    },
    checkActiveMenu(names) {
      if (Array.isArray(names)) {
        var active = false;
        for (var i = 0; i < names.length; i++) {
          const nameToCheck = names[i].toLowerCase
            ? names[i].toLowerCase()
            : names[i];
          const currentRouteName = this.$route.name
            ? this.$route.name.toLowerCase()
            : "";
          if (nameToCheck == currentRouteName) {
            active = true;
            break;
          }
        }
        return active;
      } else {
        const nameToCheck = names.toLowerCase ? names.toLowerCase() : names;
        const currentRouteName = this.$route.name
          ? this.$route.name.toLowerCase()
          : "";
        return nameToCheck == currentRouteName;
      }
    },

    checkRouteForCollapse() {
      if (this.$route.path === "/clinic") {
        this.sidebarCollapsed = true;
      }

      // Close mobile sidebar on route change
      if (window.innerWidth <= 768) {
        document.body.classList.remove("mobile-sidebar-open");
      }

      eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      this.updateBodyClass();
      this.updateTextVisibility();
    },

    navigateBack() {
      window.history.back();
    },

    // === State Management Methods ===
    updateBodyClass() {
      // Add or remove CSS class to body for responsive content-wrapper styling
      if (this.effectivelyCollapsed) {
        document.body.classList.add("sidebar-collapsed");
        document.body.classList.remove("sidebar-expanded");
      } else {
        document.body.classList.add("sidebar-expanded");
        document.body.classList.remove("sidebar-collapsed");
      }
    },

    updateTextVisibility() {
      if (this.textDelayTimer) {
        clearTimeout(this.textDelayTimer);
        this.textDelayTimer = null;
      }

      const isMobile = this.isMobile;

      if (isMobile) {
        if (this.mobileOpen) {
          this.textDelayTimer = setTimeout(() => {
            this.showText = true;
          }, 150);
        } else {
          this.showText = false;
        }
      } else {
        if (this.effectivelyCollapsed) {
          this.showText = false;
        } else {
          this.textDelayTimer = setTimeout(() => {
            this.showText = true;
          }, 300);
        }
      }
    },

    // === Event Handlers ===
    handleMouseEnter() {
      // Only expand on hover for desktop devices and when collapsed
      if (!this.isTouchDevice && this.sidebarCollapsed) {
        this.clearAutoCollapseTimer();

        // Add delay before expanding to prevent accidental expansion
        this.hoverExpandTimer = setTimeout(() => {
          this.isTemporarilyExpanded = true;
          this.updateBodyClass();
          this.updateTextVisibility();
          // Emit state change to navbar
          eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
        }, 500);
      }
    },
    handleMouseLeave() {
      // Clear hover expand timer if user leaves before delay completes
      if (this.hoverExpandTimer) {
        clearTimeout(this.hoverExpandTimer);
        this.hoverExpandTimer = null;
      }

      // Auto-collapse after delay for desktop devices
      if (
        !this.isTouchDevice &&
        this.sidebarCollapsed &&
        this.isTemporarilyExpanded
      ) {
        this.startAutoCollapseTimer(800); // Slightly longer delay for better UX
      }
    },
    handleTouchStart() {
      // Expand sidebar on touch for touch devices (don't toggle back)
      if (this.isTouchDevice && this.sidebarCollapsed) {
        this.clearAutoCollapseTimer();

        // Only expand if not already temporarily expanded
        if (!this.isTemporarilyExpanded) {
          this.isTemporarilyExpanded = true;
          this.updateBodyClass();
          this.updateTextVisibility();
          // Emit state change to navbar
          eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
        }

        // Touch devices: stay open until user touches outside (handled by backdrop)
      }
    },

    handleBackdropClick(event) {
      // Mobile sidebar logic
      if (
        window.innerWidth <= 768 &&
        document.body.classList.contains("mobile-sidebar-open")
      ) {
        const isHamburgerButton =
          event.target.closest('.nav-link[href="#"]') &&
          event.target.closest(".navbar-nav");

        if (isHamburgerButton) {
          return;
        }

        const sidebar = this.$el;
        if (sidebar && !sidebar.contains(event.target)) {
          document.body.classList.remove("mobile-sidebar-open");
        }
      }
      // Desktop sidebar logic - auto-collapse when expanded
      else if (window.innerWidth > 768 && !this.effectivelyCollapsed) {
        const isHamburgerButton =
          event.target.closest('.nav-link[href="#"]') &&
          event.target.closest(".navbar-nav");

        if (isHamburgerButton) {
          return;
        }

        const isMenuClick = event.target.closest(
          ".nav-link, .router-link-active, a[href], button, .btn, .nav-item"
        );
        const sidebar = this.$el;
        const isInsideSidebar = sidebar && sidebar.contains(event.target);

        if (isMenuClick || isInsideSidebar) {
          return;
        }

        if (!this.isTemporarilyExpanded) {
          this.sidebarCollapsed = true;
        } else {
          this.isTemporarilyExpanded = false;
        }

        this.clearAutoCollapseTimer();
        this.updateBodyClass();
        this.updateTextVisibility();
        eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      }
    },

    handleWindowResize() {
      this.windowWidth = window.innerWidth;

      if (window.innerWidth > 768) {
        document.body.classList.remove("mobile-sidebar-open");
        this.sidebarCollapsed = true;
        this.isTemporarilyExpanded = false;
        this.updateBodyClass();
        this.updateTextVisibility();
        eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      } else {
        document.body.classList.remove("mobile-sidebar-open");
        this.isTemporarilyExpanded = false;
        this.updateBodyClass();
        this.updateTextVisibility();
        eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      }
    },

    // === Timer Management ===
    startAutoCollapseTimer(delay) {
      this.clearAutoCollapseTimer();
      this.autoCollapseTimer = setTimeout(() => {
        this.isTemporarilyExpanded = false;
        this.updateBodyClass();
        this.updateTextVisibility();
        // Emit state change to navbar
        eventBus.$emit("sidebarStateChanged", this.effectivelyCollapsed);
      }, delay);
    },
    clearAutoCollapseTimer() {
      if (this.autoCollapseTimer) {
        clearTimeout(this.autoCollapseTimer);
        this.autoCollapseTimer = null;
      }
    },
  },
};
</script>

<style scoped>
.version-info {
  font-size: 0.7rem;
  opacity: 0.6;
}

/* Enhanced nav-link styling with minimal polish */
.component-menubar-sidebar .nav-link {
  color: #2c3e50 !important;
  border-radius: 6px !important;
  margin: 3px 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
  position: relative !important;
  overflow: hidden !important;
}

.component-menubar-sidebar .nav-link:hover {
  background: linear-gradient(
    135deg,
    rgba(66, 165, 245, 0.08),
    rgba(66, 165, 245, 0.04)
  ) !important;
  color: #1976d2 !important;
  transform: translateX(2px) !important;
  box-shadow: 0 2px 8px rgba(66, 165, 245, 0.15) !important;
}

.component-menubar-sidebar .nav-link.router-link-active {
  background: linear-gradient(135deg, #e3f2fd, #f0f8ff) !important;
  color: #1976d2 !important;
  border-radius: 6px !important;
  margin: 3px 8px !important;
  border-left: 3px solid #1976d2 !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2) !important;
}

/* Enhanced icon styling */
.component-menubar-sidebar .nav-link i {
  color: #546e7a !important;
  font-size: 1.1rem !important;
  opacity: 0.85 !important;
  transition: all 0.3s ease !important;
  width: 1.2rem !important;
  text-align: center !important;
}

.component-menubar-sidebar .nav-link:hover i {
  color: #1976d2 !important;
  opacity: 1 !important;
  transform: scale(1.05) !important;
}

.component-menubar-sidebar .nav-link.router-link-active i {
  color: #1976d2 !important;
  opacity: 1 !important;
}

/* Enhanced button styling for dropdown toggles */
.component-menubar-sidebar .btn-link {
  color: #2c3e50 !important;
  border-radius: 6px !important;
  margin: 3px 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
  border: none !important;
  position: relative !important;
}

.component-menubar-sidebar .btn-link:hover {
  color: #1976d2 !important;
  background: linear-gradient(
    135deg,
    rgba(66, 165, 245, 0.08),
    rgba(66, 165, 245, 0.04)
  ) !important;
  transform: translateX(2px) !important;
  box-shadow: 0 2px 8px rgba(66, 165, 245, 0.15) !important;
}

/* Enhanced active state for dropdown buttons */
.component-menubar-sidebar .btn-link.bg-secondary {
  background: linear-gradient(135deg, #e3f2fd, #f0f8ff) !important;
  color: #1976d2 !important;
  border-radius: 6px !important;
  margin: 3px 8px !important;
  border-left: 3px solid #1976d2 !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2) !important;
}

.component-menubar-sidebar .btn-link.bg-secondary:hover {
  background-color: #bbdefb !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
}

/* Active state icons for dropdown buttons */
.component-menubar-sidebar .btn-link.bg-secondary i {
  color: #1976d2 !important;
}

/* Collapse button styling */
.btn-link:focus {
  box-shadow: none;
}

/* Enhanced sidebar container */
.component-menubar-sidebar {
  overflow-x: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08) !important;
}

/* Enhanced default nav-link styling */
.component-menubar-sidebar .nav-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.65rem 1rem;
  min-height: 2.8rem;
  line-height: 1.4;
}

/* This section is now handled by enhanced icon styling above */

/* When sidebar is collapsed on desktop only, center content but maintain icon size */
@media (min-width: 769px) {
  body.sidebar-collapsed .component-menubar-sidebar .nav-link {
    justify-content: center;
    padding: 0.5rem 0.25rem;
    /* Reduce horizontal padding for better centering */
    margin: 2px 4px !important;
    /* Reduce horizontal margins for collapsed state */
  }

  /* Ensure buttons also get proper collapsed styling */
  body.sidebar-collapsed .component-menubar-sidebar .btn-link {
    justify-content: center;
    padding: 0.5rem 0.25rem;
    margin: 2px 4px !important;
  }

  /* Active states in collapsed mode - maintain centering */
  body.sidebar-collapsed .component-menubar-sidebar .nav-link.bg-secondary,
  body.sidebar-collapsed
    .component-menubar-sidebar
    .nav-link.router-link-active,
  body.sidebar-collapsed .component-menubar-sidebar .btn-link.bg-secondary {
    justify-content: center;
    margin: 2px 4px !important;
    padding: 0.5rem 0.25rem;
  }

  /* Collapsed navbar brand centering */
  body.sidebar-collapsed .component-menubar-sidebar .navbar-brand {
    justify-content: center;
    padding: 1rem 0.5rem;
  }
}

/* Ensure collapsed active items maintain rounded corners on all screen sizes */
body.sidebar-collapsed .component-menubar-sidebar .nav-link.bg-secondary,
body.sidebar-collapsed .component-menubar-sidebar .nav-link.router-link-active,
body.sidebar-collapsed .component-menubar-sidebar .btn-link.bg-secondary {
  border-radius: 8px !important;
}

/* Mobile sidebar - always left-aligned and high z-index */
@media (max-width: 768px) {
  .component-menubar-sidebar {
    z-index: 1000 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    height: 100vh !important;
    width: 250px !important;
  }

  .component-menubar-sidebar .nav-link,
  .component-menubar-sidebar .btn-link {
    justify-content: flex-start !important;
    padding: 0.5rem 1rem !important;
    margin: 2px 8px !important;
  }

  .component-menubar-sidebar .navbar-brand {
    justify-content: flex-start !important;
    padding: 1rem !important;
  }

  /* Consistent icon spacing on mobile */
  .component-menubar-sidebar .nav-link i,
  .component-menubar-sidebar .btn-link i {
    margin-right: 0.5rem !important;
  }

  /* Ensure mobile sidebar is above everything */
  body.mobile-sidebar-open .component-menubar-sidebar {
    z-index: 1001 !important;
    transform: translateX(0) !important;
  }
}

/* Active state highlighting for nav items - Modern rounded corners */
.component-menubar-sidebar .nav-item.bg-secondary,
.component-menubar-sidebar .nav-item.bg-secondary .nav-link,
.component-menubar-sidebar .nav-link.bg-secondary,
.component-menubar-sidebar .text-dark.bg-secondary {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
  margin: 2px 8px !important;
}

.component-menubar-sidebar .nav-item.bg-secondary:hover,
.component-menubar-sidebar .nav-item.bg-secondary .nav-link:hover,
.component-menubar-sidebar .nav-link.bg-secondary:hover,
.component-menubar-sidebar .text-dark.bg-secondary:hover {
  background-color: #bbdefb !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
}

/* Active state icons for bg-secondary items - Multiple selectors */
.component-menubar-sidebar .nav-item.bg-secondary i,
.component-menubar-sidebar .nav-item.bg-secondary .nav-link i,
.component-menubar-sidebar .nav-link.bg-secondary i,
.component-menubar-sidebar .text-dark.bg-secondary i {
  color: #1976d2 !important;
}

/* Bootstrap Vue specific overrides - Modern rounded corners */
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary,
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary a,
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary .nav-link {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
  margin: 2px 8px !important;
}

.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary:hover,
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary a:hover,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.bg-secondary
  .nav-link:hover {
  background-color: #bbdefb !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
}

/* Bootstrap Vue icon overrides */
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary i,
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary a i,
.component-menubar-sidebar .nav.flex-column .nav-item.bg-secondary .nav-link i {
  color: #1976d2 !important;
}

/* Ultimate override - Modern rounded corners with maximum specificity */
.component-menubar-sidebar .nav.flex-column .nav-item.text-dark.bg-secondary,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary
  a.nav-link,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary
  .nav-link.text-dark {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
  margin: 2px 8px !important;
}

.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary:hover,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary
  a.nav-link:hover,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary
  .nav-link.text-dark:hover {
  background-color: #bbdefb !important;
  color: #1976d2 !important;
  border-radius: 8px !important;
}

.component-menubar-sidebar .nav.flex-column .nav-item.text-dark.bg-secondary i,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary
  a.nav-link
  i,
.component-menubar-sidebar
  .nav.flex-column
  .nav-item.text-dark.bg-secondary
  .nav-link.text-dark
  i {
  color: #1976d2 !important;
}

/* Ensure popover links are properly styled */
.component-menubar-sidebar .popover .text-dark {
  color: #333 !important;
}

.component-menubar-sidebar .popover .text-dark:hover {
  color: #007bff !important;
  text-decoration: underline;
}

/* Enhanced text animation with smoother transitions */
.component-menubar-sidebar span {
  opacity: 0;
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(-8px);
}

/* Smooth fade-in with slide effect */
.component-menubar-sidebar span[style*="display: block"],
.component-menubar-sidebar span:not([style*="display: none"]) {
  opacity: 1;
  transform: translateX(0);
}

/* Enhanced version info styling */
.version-info {
  font-size: 0.7rem;
  opacity: 0.5;
  padding: 0.5rem;
  text-align: center;
  color: #78909c !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
  transition: opacity 0.3s ease !important;
}

.version-info:hover {
  opacity: 0.8;
}

/* Enhanced brand text styling */
.brand-text {
  font-weight: 700 !important;
  font-size: 1.3rem !important;
  color: rgb(56, 104, 156) !important;
  letter-spacing: 0.5px !important;
  font-family: "Noto Sans Thai", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, sans-serif !important;
  text-shadow: 0 1px 2px rgba(25, 118, 210, 0.1) !important;
  position: relative !important;
  top: 2px !important;
  transition: all 0.3s ease !important;
}

/* Disabled menu item styling with maximum specificity */
.component-menubar-sidebar .nav.flex-column .nav-item.disabled-menu-item,
.component-menubar-sidebar .nav.flex-column .nav-item.disabled-menu-item:hover,
.component-menubar-sidebar .nav.flex-column .nav-item.disabled-menu-item:focus {
  color: #6c757d !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  background: transparent !important;
  transform: none !important;
  box-shadow: none !important;
}
</style>
